import Sortable from "sortablejs/modular/sortable.core.esm.js"

import * as $ from "jquery"

export default function actionFieldsSortable(updateUrl) {
  const _url = updateUrl

  function reorderActionFields() {
    let actionFieldIds = ""

    $.each($(".field-list li"), function () {
      actionFieldIds =
        actionFieldIds + "&item_ids[]=" + $(this).data("action-field-id")
    })
    $.ajax({
      url: _url,
      data:
        actionFieldIds +
        "&authenticity_token=" +
        encodeURIComponent(window.App.authenticityToken),
      type: "POST",
      success() {
        App.Scripts.partners.displayFlash("Action fields reordered")
      },
      error() {
        App.Scripts.partners.displayFlash(
          "There has been an error reordering the action fields, try again!",
          "error"
        )
      },
    })
  }

  const inputsEl = document.getElementById("input-list")
  return Sortable.create(inputsEl, {
    animation: 150,
    onUpdate: reorderActionFields,
  })
}
